import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import { Link } from "react-router-dom";
import 'datatables.net-fixedcolumns';
import {css} from "@emotion/core";
import * as moment from "moment";
import {connect}  from  "react-redux";
import loadingGif from "../../assets/img/loading.gif";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import { Collapse, Button, Input, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { isApiResponse, isReportAccess, date_range_config, aplloClient, user_activities } from '../../helpers/utils.js';
import MultiCsvReportDownload from '../DownloadReport/MultiCsvReportDownload.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import CrispBankFilter from '../../filters/CrispBankFilter.jsx';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('30', '0', '2020-02-01','0');
var PcReport='';

class ComplaintReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            ciutidIds: '',
            loading:false,
            isChange: false,
            object_code:[],
            state_code:"",
            tableHeaders:[],
            tableBody:[],
            bank_names:"",
            download_limit:31,
            newOrgModel: false,
        }

    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        isReportAccess(AllAccessPermissions, "crisp_police_complaint_report");
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        let subMenuPermissions = [];
        let reportPermissions = [];
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='report'){
                reportPermissions.push(permissionName.access_name);
            }
        });

        this.setState({
            reportPermissionsArray:reportPermissions,
            user_id:decoded._id
        });


        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
            email:decoded.email
        });


    }
    componentDidUpdate() {

    }
    componentDidMount() {
        //this.get_download_limit();
        this.get_filtered_complaint_report('');
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'live_transaction_dump_report','sparcs')

    }
    get_download_limit(){
        axios.get(config.get('API_URL')+'/filters/get-grd-download-limit/',
       {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {

            }
        }).then(response => {
            console.log(response.data);
            this.setState({
                download_limit:response.data
            })


        }).catch(error => {
          console.log(error);
        });
    }


    downLoadPcReport (e){
        let filters = {
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            report_code:'complaint_report',
            user_id: this.state.user_id,
            bank: this.state.bank_names,
            download: 1,
        }
        this.setState({
            filters:filters
        })
        this.refs.downloadAllReport.downLoadReport(filters, '/crisp_reports/complaint_report','complaint_report','60');
    }

    get_filtered_complaint_report() {

        var that = this;
        var a = moment(this.state.todSend);
        var b = moment(this.state.yestSend);


        var postData = {
            bank: this.state.bank_names,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            report_code:'complaint_report',
            user_id: this.state.user_id,
        };
        if ($.fn.DataTable.isDataTable('#PcReport')) {
            $('#PcReport').DataTable().clear().destroy();
        }

        PcReport = $('#PcReport').DataTable(
            {
                order:[],
                //"dom": 'fltip',
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": true,
                "responsive": false,
                "scrollX": true,
                "searching": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                fixedColumns:   {
                                leftColumns: 0,
                                rightColumns: 1
                            },
                ajax: {
                    url:config.get('API_URL')+ "/CrispReport/complaint_report",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                        console.log("error", data);
                    },
                    complete: function (data) {
                        isApiResponse(true)
                        console.log("complete", data);
                    },
                },

                columns:[
                    { "data": "Date of Receipt" },
                    { "data": "Ticket Number" },
                    { "data": "Case Number" },
                    { "data": "Sender" },
                    { "data": "Notice Details" },
                    { "data": "Disputed Details" },
                    { "data": "Customer Details" },
                    { "data": "Merchant Details" },
                    { "data": "Action Taken" },
                    { "data": "Pending Items" },
                    { "data": "Further Actions" },
                    { "data": "Additional Notes" },
                    { "data": "id"}

                    ],
                "columnDefs": [
                    {  render: function (data) {
                            return "<div class='text-wrap width-80'>" + data + "</div>";
                        },
                        "width": "80px",
                        "targets": [0,1,5]
                    },
                    {
                        render: function (data, type, full, meta) {
                            if(data===null || data===''|| data ==='null'){
                            data = '';
                            }
                            return "<div class='text-wrap width-150'>" + data + "</div>";
                        },
                        "targets": [2,3,4,6,7,8,9,10]
                    },
                    {
                        "width": "200px",
                        "targets": 7,
                        "data": "data",
                        "createdCell": (td, cellData, rowData, row, col) => {
                            $(td).text('');

                            if(rowData["Merchant Details"]==null || rowData["Merchant Details"]=='null' || rowData["Merchant Details"]=='') {
                                $(td).text('');

                            }
                            else {
                                var merchantDetails = rowData["Merchant Details"];
                                if (merchantDetails.length > 80) {
                                    var trimmedString = merchantDetails.substring(0, 70);
                                    $(td).append(
                                        "<div class='text-wrap width-150'>" +
                                        trimmedString +
                                        '... <a href="#" data-tip="Stop" title="View" id="View" class="">View All..</a>' +
                                        "</div>"
                                    );
                                    $(td).click(e => {
                                        this.toggleNewOrgModel(e, merchantDetails, "Merchant Details");
                                    });
                                } else {
                                    $(td).append("<div class='text-wrap width-150'>" + merchantDetails + "</div>");
                                }


                            }
                        },
                        bSortable: false,
                    },
                    {

                        "className":"text-center",
                        "targets": 12,
                        "data": "data",
                        "createdCell": (td, cellData, rowData, row, col) => {
                            $(td).text('');
                                $(td).append('<a href="#" data-tip="Stop" title="View" id="edit" class="btn btn-default actionBtn btn-edit"><span class="glyphicon glyphicon-edit" aria-hidden="true"></span></a>&nbsp;');
                                $(td).append('<a href="#" data-tip="Delete" title="Delete" id="Delete" class="btn btn-default actionBtn btn-edit"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span</span></a>&nbsp;');
                                $(td).find('#edit').click(e => {
                                    e.preventDefault(); // Prevent default link behavior
                                    this.complaint_edit(e, rowData.id);
                                });

                                $(td).find('#Delete').click(e => {
                                    e.preventDefault(); // Prevent default link behavior
                                    this.complaint_delete(e, rowData.id);
                                });
                        },
                        bSortable: false,
                    }
               ],
            });
            if(that.state.reportPermissionsArray.includes("crisp_add_new_complaint")===true) {
                PcReport.columns(12).visible(true);
            }
            else {
                PcReport.columns(12).visible(false);
            }

        }
    complaint_edit(e,id) {
        const { history } = this.props;
        history.push('/admin/edit-complaint/'+id);
    }
    complaint_delete(e,id) {
        confirmAlert({
            title: 'Question',
            message: 'Are you sure you want to delete this user?.',
            buttons: [{
                label: 'Yes',
                onClick: () => {
                    this.handleClickDelete(id);
                }
            },
                {
                    label: 'No',
                }
            ]
        });
    }
    handleClickDelete(id) {
        var data = {
            id: id,
            delete_request_by: this.state.email
        }
        axios.post(config.get('API_URL') + '/CrispReport/delete_complaint/', data,  {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            this.get_filtered_complaint_report();
            this.handleNotificationClick("tr", 1, response.data.message);
        })
        .catch(error => {
            console.error(error);
            const errorMsg = error.response?.data?.message || 'Something went wrong while deleting the complaint.';
            this.handleNotificationClick("tr", 3, errorMsg);
            //this.props.handleClick("tr", 2, errorMsg);
        });
    }
    toggleNewOrgModel(e, all_data, column_type) {
        this.setState({
            newOrgModel: !this.state.newOrgModel,
            all_data: all_data,
            column_type: column_type
        })
    }
    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);

//         this.refs.crispBankFilter.resetCrispBankFilter();
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            bank_names:'',
            ciutidIds: '',
            isChange: false

        })

        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()
        }.bind(this), 200);
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
    }
    handleBank = (optionSelected, bank_names) =>
    {
        this.setState({
            bank_names:bank_names,
            isChange: true
        });
    }

    render() {
        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-8 no-padd">
                                    <div className="header">
                                        <h4 className="title">Complaint Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-4 text-right">
                                    {this.state.reportPermissionsArray.includes("crisp_add_new_complaint")===true?
                                    <Link className="" to="/admin/create-new-complaint/">
                                        <br/>
                                        <button className="campaignButton" role="button"><span
                                        className="glyphicon glyphicon-plus" aria-hidden="true"></span>Add New Complaint</button>
                                     </Link> :null}
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                <div><label>Date Filter: </label></div>
                                                <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                            </div>
{/*                                             <div className="col-md-3 filter-bottom5 padd-5"> */}
{/*                                                 <label> ASO Name </label> */}
{/*                                                 <CrispBankFilter ref="crispBankFilter" onSelectCrispBank = {this.handleBank} /> */}
{/*                                                 <div className="clearfix"></div> */}
{/*                                             </div> */}

                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_complaint_report.bind(this)}>Apply</button>
                                            <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>


                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>

                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.downLoadPcReport.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>

                                    <div className="content-tdetails-table table-full-width marginTop0">
                                        <table id="PcReport" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Date of Receipt</th>
                                                    <th>Ticket Number</th>
                                                    <th>Case Number</th>
                                                    <th>Sender</th>
                                                    <th>Notice Details</th>
                                                    <th>Disputed Details</th>
                                                    <th>Customer Details</th>
                                                    <th>Merchant Details</th>
                                                    <th>Action Taken</th>
                                                    <th>Pending Items</th>
                                                    <th>Further Actions</th>
                                                    <th>Additional Notes</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <MultiCsvReportDownload ref="downloadAllReport" />

                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal isOpen={this.state.newOrgModel} toggle={this.toggleNewOrgModel.bind(this)} >
                <ModalHeader toggle={this.toggleNewOrgModel.bind(this)}>{this.state.column_type}</ModalHeader>
                <ModalBody>
                    <div className="issue_container">
                        {this.state.all_data}
                    </div>
                </ModalBody>
                <ModalFooter>

                    <Button color="secondary" onClick={this.toggleNewOrgModel.bind(this)}>Cancel</Button>
                </ModalFooter>
            </Modal>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
        currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
}
export default connect(null,mapDispatchToProps)(ComplaintReport)